/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { object, string } from 'prop-types';
import { useUIDSeed } from 'react-uid';
import CustomSlider from '../Common/CustomSlider';
import DesktopMobile from '../../../../helpers/DesktopMobile/DesktopMobile';

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
        height: 'auto',
    },
    title: {
        position: 'relative',
        textAlign: 'center',
        fontFamily: 'ivypresto-text, PlayfairDisplayBold, Crimson, Garamond, Times, serif',
        [theme.breakpoints.down(600)]: {
            fontSize: '1.8rem',
        },
        fontWeight: 'normal',
    },
    sliderWrapper: {
        margin: '25px 0',
        '& .slick-current': {
            [theme.breakpoints.down(800)]: {
                '& .info-block--heading': {
                    opacity: '1',
                },
            },
        },
        [theme.breakpoints.down(600)]: { margin: '15px 0' },
    },
    cardHeading: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        top: '0',
        left: '0',
        right: '0',
        height: '150px',
        transition: '500ms opacity ease-in',
        [theme.breakpoints.down(800)]: {
            opacity: '0.85',
        },
        backgroundColor: '#3E8637',
        '& > svg': {
            width: '100px',
        },
    },
    cardWrapper: {
        width: '340px',
        height: '100%',
        '& .MuiCard-root': {
            height: '100%',
            borderRadius: '8px',
            boxShadow: 'none !important',
        },
        '&.card-heading--border > .MuiCard-root': {
            border: '1px solid #DADADA',
        },
        '& h1,& h2,& h3,& h4,& h5,& h6': {
            fontFamily: 'ivypresto-text, PlayfairDisplayBold, Crimson, Garamond, Times, serif',
            margin: 0,
            fontSize: '18px',
            fontWeight: 'normal',
            lineHeight: '28px',
            marginBottom: '15px',
            [theme.breakpoints.down(600)]: {
                lineHeight: '22px',
                fontSize: '18px',
            },
        },
        '& p': {
            fontSize: '16px',
            lineHeight: '20px',
            marginBottom: '10px',
        },
    },
    cardContent: {
        textAlign: 'center',
    },
}));

function InfoBlock({ item, mapKey }) {
    const classes = useStyles();
    const seed = useUIDSeed();

    if (typeof window === 'undefined') return null;

    const [windowInnerWidth, setWindowInnerWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setWindowInnerWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div key={mapKey} id="info-block" className={classes.container}>
            <h1 className={classes.title}>{item?.title || ''}</h1>
            <CustomSlider parentClass={classes.sliderWrapper} slideWidth={windowInnerWidth > 600 ? 330 : 260} length={item?.tiles?.length || 0}>
                {item?.tiles?.map((tile, ind) => (
                    <div key={seed(ind)} className={`${classes.cardWrapper} card-heading--border`}>
                        <Card>
                            <div style={{ backgroundColor: tile?.tile_background_color || '#3E8637' }} className={`${classes.cardHeading} info-block--heading`}>
                                <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                    <DesktopMobile
                                        breakpoint={600}
                                        desktop={() => <image height={100} width={100} href={tile?.desktop_image.url || ''} aria-label={tile?.desktop_image?.description || ''} type={tile?.desktop_image?.content_type || ''} />}
                                        mobile={() => <image height={100} width={100} href={tile?.mobile_image.url || ''} aria-label={tile?.mobile_image?.description || ''} type={tile?.mobile_image?.content_type || ''} />}
                                    />
                                </svg>
                            </div>
                            <CardContent>
                                <div className={classes.cardContent}>
                                    <h5 style={{ color: tile?.text_color || '#000' }}>{tile?.header}</h5>
                                    <p style={{ color: tile?.text_color || '#000' }}>{tile?.sub_header}</p>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                ))}
            </CustomSlider>
        </div>
    );
}

InfoBlock.propTypes = {
    item: object.isRequired,
    mapKey: string.isRequired,
};

export default InfoBlock;
